var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-0",attrs:{"fluid":"","fill-height":""}},[_c('router-view',{attrs:{"name":"notifications"}}),_c('transition',{attrs:{"name":"fadeonly","mode":"out-in"}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }